
// src/utils/DebugConsole.js
const DebugConsole = {
    isEnabled: true,
    logs: [], // Store logs here
    listeners: [], // UI listeners
    maxLogs: 1000,
    initialized: false,
    originalConsole: {
        log: console.log,
        warn: console.warn,
        error: console.error,
        info: console.info
    },

    init: function () {
        if (this.initialized) return;
        this.hookConsole();
        this.addLog("info", ["Debug System Initialized (Headless Mode)"]);
        this.initialized = true;
    },

    hookConsole: function () {
        const self = this;
        ['log', 'warn', 'error', 'info'].forEach(type => {
            console[type] = function (...args) {
                self.originalConsole[type].apply(console, args);
                self.addLog(type, args);
            };
        });
    },

    addLog: function (type, args) {
        const now = new Date();
        const timeStr = `[${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}]`;

        // Toggle Button (DISABLED - User requested dedicated page)
        /*
                const toggleBtn = document.createElement('div');
                // ...
                document.body.appendChild(toggleBtn);
        */
        // Serialize args
        const message = args.map(arg => {
            if (typeof arg === 'object') {
                try {
                    return JSON.stringify(arg);
                } catch (e) {
                    return '[Object]';
                }
            }
            return String(arg);
        }).join(' ');

        const logEntry = {
            id: Date.now() + Math.random(),
            timestamp: timeStr,
            type: type,
            message: message
        };

        this.logs.push(logEntry);
        if (this.logs.length > this.maxLogs) this.logs.shift();

        // Notify listeners
        this.listeners.forEach(fn => fn(logEntry));

        // [REMOTE] Send to Server (Render Dashboard)
        this.sendToServer(logEntry);
    },

    sendToServer: function (logEntry) {
        // Prevent infinite loop if fetch fails (don't log the error)
        try {
            // Check if API is available (relative path works if served from same origin)
            // Use window.location.origin for robustness
            const apiEndpoint = '/api/log';

            fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    type: logEntry.type,
                    message: logEntry.message,
                    timestamp: logEntry.timestamp
                })
            }).catch(() => {
                // Silently fail if server is unreachable
            });
        } catch (e) {
            // Ignore
        }
    },

    // UI Components can subscribe here
    subscribe: function (callback) {
        this.listeners.push(callback);
        // Send existing logs immediately
        this.logs.forEach(log => callback(log));
    },

    unsubscribe: function (callback) {
        this.listeners = this.listeners.filter(fn => fn !== callback);
    },

    clear: function () {
        this.logs = [];
        this.listeners.forEach(fn => fn({ type: 'clear' }));
    },

    // Compatibility helpers
    log: function (msg, type = 'log') {
        this.addLog(type, [msg]);
    }
};

// Auto-init
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => DebugConsole.init());
} else {
    DebugConsole.init();
}

export default DebugConsole;
window.DebugConsole = DebugConsole;
